async function getPosts() {
  try {
    var res = await fetch(
      "https://graph.facebook.com/v19.0/17841448049372007?fields=followers_count%2Cbiography%2Cprofile_picture_url%2Cusername%2Cwebsite%2Cmedia%7Bcaption%2Ccomments_count%2Clike_count%2Cmedia_type%2Cmedia_url%2Cpermalink%2Cthumbnail_url%2Ctimestamp%2Ccomments%7D&access_token=EAAESLvZC9ApgBOzVbHIw4cHZB40OvAdX4ueDkykIYpASyo7NcgrHZAiYRKs0llQn1yES829mvtZCzp6UvaPf1H470Ob5SBlJP65CeapoB5LMF4qqFaLKZBx1L9M35f5NZAMEf8bWiOYaxEHQ0gPtoKdwHOnHMAlYf1ZAKSONsX1fjctaVMjsCRu7aE6yAyGu4dNLgVmjoex"
    );

    if (!res.ok) throw new Error("Could not fetch resource");

    var data = await res.json();
    var posts = data.media.data;
    var postCount = Math.min(posts.length, 10);
    var track = document.querySelector(".gri-ig__track");
    if (!track) return;

    var logoSrc = "https://cdn.shopify.com/s/files/1/0584/7410/2873/files/gri-mini-logo.png?v=1742479030";

    for (var i = 0; i < postCount; i++) {
      var post = posts[i];
      var card = buildCard(post, logoSrc);
      track.appendChild(card);

      card.addEventListener("click", (function(p) {
        return function() { showModal(p); };
      })(post));
    }

    // Duplicate all cards for seamless infinite loop
    var original = track.innerHTML;
    track.innerHTML = original + original;

    // Re-attach click handlers to all cards
    var allCards = track.querySelectorAll(".gri-ig__card");
    allCards.forEach(function(card, idx) {
      var postIdx = idx % postCount;
      card.addEventListener("click", (function(p) {
        return function() { showModal(p); };
      })(posts[postIdx]));
    });

  } catch (error) {
    console.log(error);
  }
}

function buildCard(post, logoSrc) {
  var card = document.createElement("div");
  card.className = "gri-ig__card";

  var imgSrc = post.thumbnail_url || post.media_url;
  var isVideo = post.media_type === "VIDEO" || (post.media_url && post.media_url.includes(".mp4"));
  var caption = post.caption || "";
  var shortCaption = caption.length > 35 ? caption.substring(0, 35) + "..." : caption;

  var reelBadge = isVideo
    ? '<div class="gri-ig__card-reel"><svg viewBox="0 0 24 24" width="10" height="10" fill="currentColor"><polygon points="5 3 19 12 5 21 5 3"/></svg> Reel</div>'
    : "";

  card.innerHTML =
    '<div class="gri-ig__card-img-wrap">' +
      '<img src="' + imgSrc + '" alt="" class="gri-ig__card-img" loading="lazy">' +
      reelBadge +
    '</div>' +
    '<div class="gri-ig__card-info">' +
      '<img src="' + logoSrc + '" alt="GRI" class="gri-ig__card-avatar" loading="lazy">' +
      '<div class="gri-ig__card-meta">' +
        '<div class="gri-ig__card-caption">' + shortCaption + '</div>' +
        '<div class="gri-ig__card-user">@gender.reveal.ideass</div>' +
      '</div>' +
    '</div>';

  return card;
}

// Modal
var modalEl = document.querySelector(".gri-ig__modal");

function showModal(post) {
  if (!modalEl) return;

  var date = new Date(post.timestamp);
  var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  var formattedDate = months[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear();

  modalEl.classList.add("active");

  var mediaContainer = modalEl.querySelector(".gri-ig__modal-media");
  var descContainer = modalEl.querySelector(".gri-ig__modal-desc");
  var dateEl = modalEl.querySelector(".gri-ig__modal-date");
  var linkEl = modalEl.querySelector(".gri-ig__modal-link");

  if (post.media_type === "VIDEO" || (post.media_url && post.media_url.includes(".mp4"))) {
    mediaContainer.innerHTML = '<video style="width:100%;height:100%;object-fit:cover;" muted autoplay><source src="' + post.media_url + '" type="video/mp4"></video>';
  } else {
    var src = post.media_url || post.thumbnail_url;
    mediaContainer.innerHTML = '<img style="width:100%;height:100%;object-fit:cover;" loading="lazy" alt="post" src="' + src + '">';
  }

  if (post.caption) descContainer.innerHTML = "<p>" + post.caption + "</p>";
  if (post.permalink) linkEl.href = post.permalink;
  if (post.timestamp) dateEl.textContent = formattedDate;
}

function closeModal() {
  if (modalEl) {
    modalEl.classList.remove("active");
    var media = modalEl.querySelector(".gri-ig__modal-media");
    if (media) media.innerHTML = "";
  }
}

document.addEventListener("DOMContentLoaded", function() {
  getPosts();

  document.addEventListener("keydown", function(e) {
    if (e.key === "Escape") closeModal();
  });

  if (modalEl) {
    modalEl.addEventListener("click", function(e) {
      if (e.target === modalEl) closeModal();
    });
  }

  var closeBtns = document.querySelectorAll(".gri-ig__modal-close");
  closeBtns.forEach(function(btn) { btn.addEventListener("click", closeModal); });
});
